module.exports = __webpack_public_path__ + "videos/partner-bg.3ec3343.mp4";